import { HallRoomActionTypes, HallRoomState } from "./types";
import { Reducer } from "redux";

const initialState: HallRoomState = {
  loading: false,
  error: null,
  isHallRoomSubmitting: false,
  isHallRoomDeleting: false,
  success: false,
  failure: false,
  deleteSuccess: false,
  page: "",
  rooms: [],
  students: [],
  isRoomSubmitting: false,
  isRoomDeleting: false,
  hall: null,
  floor: null,
  room: null,
};

const reducer: Reducer<HallRoomState> = (state = initialState, action) => {
  switch (action.type) {
    case HallRoomActionTypes.FETCH_ROOMS_REQUEST:
    case HallRoomActionTypes.FETCH_ROOMS_BY_HALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case HallRoomActionTypes.FETCH_ROOMS_SUCCESS:
    case HallRoomActionTypes.FETCH_ROOMS_BY_HALL_SUCCESS:
      return {
        ...state,
        loading: false,
        rooms: action.payload,
      };
    case HallRoomActionTypes.FETCH_ROOMS_ERROR:
    case HallRoomActionTypes.FETCH_ROOMS_BY_HALL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HallRoomActionTypes.FETCH_ROOM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case HallRoomActionTypes.FETCH_ROOM_SUCCESS:
      return {
        ...state,
        loading: false,
        room: action.payload,
      };
    case HallRoomActionTypes.FETCH_ROOM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HallRoomActionTypes.CREATE_ROOM_REQUEST:
      return {
        ...state,
        isHallSubmitting: true,
        success: false,
        failure: false,
        error: null,
      };
    case HallRoomActionTypes.CREATE_ROOM_SUCCESS:
      return {
        ...state,
        isHallSubmitting: false,
        success: true,
        failure: false,
        rooms: [...state.rooms, action.payload],
      };
    case HallRoomActionTypes.CREATE_ROOM_ERROR:
      return {
        ...state,
        isHallSubmitting: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case HallRoomActionTypes.UPDATE_ROOM_REQUEST:
      return {
        ...state,
        isHallSubmitting: true,
        success: false,
        failure: false,
        error: null,
      };
    case HallRoomActionTypes.UPDATE_ROOM_SUCCESS:
      return {
        ...state,
        isHallSubmitting: false,
        success: true,
        failure: false,
        rooms: state.rooms.map((room) =>
          room.id === action.payload.id ? action.payload : room
        ),
      };
    case HallRoomActionTypes.UPDATE_ROOM_ERROR:
      return {
        ...state,
        isHallSubmitting: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case HallRoomActionTypes.DELETE_ROOM_REQUEST:
      return {
        ...state,
        isHallDeleting: true,
        deleteSuccess: false,
        error: null,
      };
    case HallRoomActionTypes.DELETE_ROOM_SUCCESS:
      return {
        ...state,
        isHallDeleting: false,
        deleteSuccess: true,
        rooms: state.rooms.filter((room) => room.id !== action.payload),
      };
    case HallRoomActionTypes.DELETE_ROOM_ERROR:
      return {
        ...state,
        isHallDeleting: false,
        deleteSuccess: false,
        error: action.payload,
      };
    case HallRoomActionTypes.CLEAR_ROOM_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        isHallRoomSubmitting: false,
        isHallRoomDeleting: false,
        success: false,
        failure: false,
        deleteSuccess: false,
        page: "",
        rooms: [],
        students: [],
        isRoomSubmitting: false,
        isRoomDeleting: false,
        hall: null,
        floor: null,
        room: null,
      };
    default:
      return state;
  }
};

export { reducer as HallRoomReducer };
